
<template>
  <v-app id="inspire">
    <v-navigation-drawer
      v-model="drawer"
      :clipped="$vuetify.breakpoint.lgAndUp"
      app
      v-if="logueado && !esPantallaPublica"
      :width="280"
      permanent
      expand-on-hover
      dark
    >
      <v-list dense nav>
        <v-list-item link :to="{path:'/panelproveedor'}" v-if="esAdministrador || esProveedor">
          <v-list-item-icon>
            <v-icon>mdi-home</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Panel Proveedor</v-list-item-title>
        </v-list-item>

        <v-list-item link :to="{path:'/panelcontratista'}" v-if="esAdministrador || esContratista">
          <v-list-item-icon>
            <v-icon>mdi-home</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Panel Contratista</v-list-item-title>
        </v-list-item>

        <v-list-item link :to="{path:'/oportunidades'}" v-if="esAdministrador || esProveedor">
          <v-list-item-icon>
            <v-icon>mdi-briefcase</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Oportunidades</v-list-item-title>
        </v-list-item>

        <v-list-item link :to="{path:'/mispostulaciones'}" v-if="esAdministrador || esProveedor">
          <v-list-item-icon>
            <v-icon>mdi-briefcase-check</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Mis Postulaciones</v-list-item-title>
        </v-list-item>

        <v-list-item link :to="{path:'/misrequerimientos'}" v-if="esAdministrador || esContratista">
          <v-list-item-icon>
            <v-icon>mdi-briefcase-check</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Mis Requerimientos</v-list-item-title>
        </v-list-item>

        <v-list-item link :to="{path:'/misrequerimientosadmin'}" v-if="esAdministrador">
          <v-list-item-icon>
            <v-icon>mdi-briefcase-check</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Validar Requerimientos</v-list-item-title>
        </v-list-item>

        <v-list-item link :to="{path:'/empleado'}" v-if="esAdministrador">
          <v-list-item-icon>
            <v-icon>mdi-account-hard-hat</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Operador UTM</v-list-item-title>
        </v-list-item>

        <v-list-item link :to="{path:'/empresa'}" v-if="esAdministrador">
          <v-list-item-icon>
            <v-icon>mdi-office-building</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Empresas</v-list-item-title>
        </v-list-item>

        <v-list-item link :to="{path:'/contratista'}" v-if="esAdministrador">
          <v-list-item-icon>
            <v-icon>mdi-office-building</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Contratistas</v-list-item-title>
        </v-list-item>

        <v-list-item link :to="{path:'/requerimiento'}" v-if="esAdministrador || esContratista">
          <v-list-item-icon>
            <v-icon>mdi-text-box-multiple</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Solicitud de Servicio (SS)</v-list-item-title>
        </v-list-item>

        <v-list-item link :to="{path:'/postulantes'}" v-if="esAdministrador">
          <v-list-item-icon>
            <v-icon>mdi-text-box-multiple</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Atención de Requerimiento / RRQ</v-list-item-title>
        </v-list-item>

        <v-list-item link :to="{path:'/usuario'}" v-if="esAdministrador">
          <v-list-item-icon>
            <v-icon>mdi-card-account-details</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Usuarios</v-list-item-title>
        </v-list-item>

        <v-list-item link :to="{path:'/pagos'}" v-if="esAdministrador || esContratista">
          <v-list-item-icon>
            <v-icon>mdi-cash-check</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Mis Pagos</v-list-item-title>
        </v-list-item>

        <v-list-item link :to="{path:'/facturacion'}" v-if="esAdministrador || esProveedor">
          <v-list-item-icon>
            <v-icon>mdi-file-document</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Mis Facturas</v-list-item-title>
        </v-list-item>

        <v-list-item link :to="{path:'/estimacion'}" v-if="esAdministrador || esProveedor">
          <v-list-item-icon>
            <v-icon>mdi-file-document</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Mis Valorizaciones</v-list-item-title>
        </v-list-item>

        <v-list-item link :to="{path:'/estimacioncontrata'}" v-if="esAdministrador || esContratista">
          <v-list-item-icon>
            <v-icon>mdi-file-document</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Valorizaciones enviadas</v-list-item-title>
        </v-list-item>

        <v-list-item link :to="{path:'/presupuestocontratista'}" v-if="esAdministrador">
          <v-list-item-icon>
            <v-icon>mdi-cash-multiple</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Presupuesto Contratista</v-list-item-title>
        </v-list-item>

        <v-list-item link :to="{path:'/reportelocalia'}" v-if="esAdministrador">
          <v-list-item-icon>
            <v-icon>mdi-file-chart</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Reporte de Localía</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <!-- BARRA SUPERIOR -->
    <v-app-bar
      :clipped-left="$vuetify.breakpoint.lgAndUp"
      app
      color="#2A3B4D"
      dark
      v-if="logueado && !esPantallaPublica"
    >
      <!--<v-app-bar-nav-icon @click.stop="drawer = !drawer" />-->
      <v-icon large color="white" class="mr-1">mdi-database-search</v-icon>

      <!--<v-img class="mr-0 ml-3" src="@/imgs/LogoSIGSv42.png" height="38" width="110px"></v-img>-->

      <v-toolbar-title class="titulo">
        Contratos con Empresas
      </v-toolbar-title>

      <v-spacer />

      <span class="mr-4">
        <v-icon class="mr-2">mdi-account</v-icon>
        <span class="mr-4">{{ idusuario }}</span>
      </span>

      <v-btn @click="salir" v-if="logueado">
        Cerrar sesión
      </v-btn>
    </v-app-bar>

    <!-- CONTENIDO: se mantiene el diseño original -->
    <v-content class="grey lighten-5">
      <v-container fluid>
        <v-slide-y-transition mode="out-in">
          <router-view />
          <!--<loader></loader>-->
        </v-slide-y-transition>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
export default {
  props: {
    source: String
  },

  data: () => ({
    dialog: false,
    drawer: null,
    right: null,
    idusuario: localStorage.getItem('idusuario') || '',
    rol: localStorage.getItem('rol') || '',
    empresaid: Number(localStorage.getItem('empresa')) || null
  }),

  computed: {
    esPantallaPublica() {
      return this.$route.name === 'OportunidadesPublicas'
    },

    logueado() {
      this.idusuario = localStorage.getItem('idusuario') || ''
      return this.$store.state.usuario
    },

    esAdministrador() {
      return (
        this.$store.state.usuario &&
        this.$store.state.usuario.rol == "ADMINISTRADOR"
      )
    },

    esProveedor() {
      return (
        this.$store.state.usuario &&
        this.$store.state.usuario.rol == "PROVEEDOR"
      )
    },

    esContratista() {
      return (
        this.$store.state.usuario &&
        this.$store.state.usuario.rol == "CONTRATISTA"
      )
    }
  },

  created() {
    this.idusuario = localStorage.getItem('idusuario') || ''
    this.rol = localStorage.getItem('rol') || ''
    this.empresaid = Number(localStorage.getItem('empresa')) || null
  },

  methods: {
    salir() {
      localStorage.removeItem('idusuario')
      localStorage.removeItem('rol')
      localStorage.removeItem('empresa')
      localStorage.removeItem('empresacontratista')
      localStorage.clear()
      this.$store.dispatch("salir")
    }
  }
}
</script>

<style scoped>
* {
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  font-weight: 300;
}

.titulo {
  font-size: 20px;
}

.my-input input {
  text-transform: uppercase;
}
</style>
